<template>
  <p v-if="showPaymentLegalDisclaimer">
    {{ i18n(translations.paymentLegalDisclaimer) }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useMarketPaymentMethods } from '../../composables/useMarketPaymentMethods'
import { isPaymentMethodEnabled } from '../../helpers/methods'

import translations from './PaymentLegalDisclaimer.translations'

const i18n = useI18n()
const { market } = useMarketplace()
const { data: methods } = useMarketPaymentMethods()
const showPaymentLegalDisclaimer = computed(
  () =>
    market.countryCode === MarketCountryCode.GB &&
    methods.value?.some(
      (method) =>
        method.bmCode.includes('klarna') && isPaymentMethodEnabled(method),
    ),
)
</script>
